(() => {
  class DailyOffer extends HTMLElement {
    static secondsUntilMidnight(now = new Date()) {
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      return Math.max(0, Math.ceil((midnight - now) / 1000));
    }
    connectedCallback() {
      if (this.running) return;
      this.running = true;
      this.clock = this.querySelector('[data-offer-time]');
      this.tick = () => {
        const seconds = DailyOffer.secondsUntilMidnight();
        const formatted = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(n => String(n).padStart(2, '0')).join(':');
        this.clock.textContent = formatted;
        this.clock.setAttribute('aria-label', `${formatted} remaining until your local midnight`);
      };
      this.tick();
      this.timer = setInterval(this.tick, 1000);
      document.addEventListener('visibilitychange', this.tick);
      const announcement = document.querySelector('.announcement-bar');
      if (announcement && 'ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.style.setProperty('--ll-offer-height', `${announcement.getBoundingClientRect().height * 1.125}px`));
        this.observer.observe(announcement);
      }
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.tick);
      this.observer?.disconnect();
      this.running = false;
    }
  }
  if (!customElements.get('limitless-daily-offer')) customElements.define('limitless-daily-offer', DailyOffer);
})();
